// extracted by mini-css-extract-plugin
export default {"total":"HomeMenu_total__hoS5X","logo":"HomeMenu_logo__sSzL1","image":"HomeMenu_image__Jv2Mi","attribution":"HomeMenu_attribution__Vv-zI","main":"HomeMenu_main__SOsLP"};